import { HandleError } from "source/app/presentation/Shared/HandleError";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { OnErrorAddLogEntry } from "source/app/services/Log/AddEntry";


export async function AddPointToLogAsync(task: string) {
    try {
        MotwLogicServer.PostUnsungHeroPointAsync(task);
    } catch (e) {
        OnErrorAddLogEntry();
        HandleError(e);
    }
}
